module.exports = "<div class=\"container\">\n    <p class=\"h3\">{{$ctrl.translate[$ctrl.selectedLanguage].pageTitle}}</p>\n    <appointment-finder language=\"$ctrl.selectedLanguage\">\n    </appointment-finder>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/search-appointment/search-appointment.html
// module id = 604
// module chunks = 0